import { useEffect, useState } from "react";
import api from "@/lib/api";

const GEO_KEY = "homiie_geo";
const EVT = "homiie-geo";

export function getGeo() {
    try { return JSON.parse(localStorage.getItem(GEO_KEY) || "null"); } catch { return null; }
}

export function saveGeo(g) {
    localStorage.setItem(GEO_KEY, JSON.stringify({ ...g, at: Date.now() }));
    window.dispatchEvent(new Event(EVT));
}

export const geoLabel = (g) => (g ? (g.area?.name && g.services_available ? g.area.name : g.locality || g.area?.name || g.city) || "Current location" : null);

const position = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("unsupported"));
    navigator.geolocation.getCurrentPosition(resolve, (e) => reject(new Error(e.code === 1 ? "denied" : "unavailable")),
        { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 });
});

// Gets GPS position, resolves address + service-area availability on the backend, and caches it.
export async function detectLocation() {
    const pos = await position();
    const { data } = await api.post("/location/resolve", { lat: pos.coords.latitude, lng: pos.coords.longitude });
    saveGeo(data);
    return data;
}

export async function resolvePincode(pincode) {
    const { data } = await api.post("/location/resolve", { pincode });
    saveGeo({ ...data, locality: data.locality || `PIN ${pincode}` });
    return data;
}

export const geoErrorText = (e) => ({
    unsupported: "Location isn't supported on this device.",
    denied: "Location permission is blocked. Allow it in your browser or phone settings, or pick an address.",
}[e?.message] || "Couldn't get your location. Please try again or pick an address.");

// Location fields sent with every Care request (server enforces the Care city geofence).
export const careLoc = () => {
    const g = getGeo() || {};
    return { pincode: g.pincode || undefined, lat: g.lat ?? undefined, lng: g.lng ?? undefined };
};

export function useGeo() {
    const [geo, setGeo] = useState(getGeo());
    useEffect(() => {
        const on = () => setGeo(getGeo());
        window.addEventListener(EVT, on);
        return () => { window.removeEventListener(EVT, on); };
    }, []);
    return geo;
}
